import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Check if we're in a Capacitor native app
const isNative = typeof window !== 'undefined' && 
  window.hasOwnProperty('Capacitor') && 
  (window as any).Capacitor?.isNativePlatform?.();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // For native apps, we handle the session manually via deep links
    detectSessionInUrl: !isNative,
    // Use localStorage for session storage (works in Capacitor WebView)
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    // Use implicit flow everywhere to avoid PKCE code_verifier issues
    // Our AuthCallback already supports implicit tokens from the URL hash
    flowType: 'implicit',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-client-info': isNative ? 'metefy-android' : 'metefy-web',
    },
  },
  // Connection pooling is handled automatically by Supabase's REST API
  // These settings optimize connection reuse and reduce connection overhead
});
